/* eslint-disable no-new */
import { Toggle } from './toggle';

export default(() => {
    const html = document.querySelector('html');

    // Save theme body class
    let theme = null;
    theme = document.body.classList.contains('theme-light') ? 'theme-light' : null;
    theme = document.body.classList.contains('theme-dark') ? 'theme-dark' : theme;

    const toggles = Array.from(document.querySelectorAll('.js-nav-toggle'));
    toggles.forEach((toggle) => {
        new Toggle({
            source: toggle,
            target: document.querySelector('html'),
            sourceClass: null,
            targetClass: 'nav-active',
        });
    });


    const pageLinks = Array.from(document.querySelectorAll('span[data-page-link]'));
    pageLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            const page = document.querySelector(`[data-page="${link.dataset.pageLink}"]`);
            page.classList.add('is-active');
        });
    });

    const backs = Array.from(document.querySelectorAll('[data-back]'));
    backs.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const page = link.closest('[data-page]');
            page.classList.remove('is-active');
        });
    });

    const links = Array.from(document.querySelectorAll('.header__navigation > li.has-megamenu'));
    links.forEach((link) => {
        link.addEventListener('mouseover', () => {
            html.classList.add('megamenu-active');
            document.body.classList.remove(theme);
        });

        link.addEventListener('mouseout', () => {
            html.classList.remove('megamenu-active');
            document.body.classList.add(theme);
        });
    });

    const header = document.querySelector('header');
    const nav = document.querySelector('.header__navigation');

    if (header) {
        header.addEventListener('click', () => {
            html.classList.remove('megamenu-active');
            nav.style.pointerEvents = 'none';
            setTimeout(() => {
                nav.style.pointerEvents = 'auto';
            }, 200);
        });
    }

})();
